import React from 'react';
import Draft from '~/shared-components/Draft';
import { RpcPostContent, RpcUpdate } from '~/post/types';
import PostTag from '~/shared-components/PostTag';
import { useCampaignTag } from '~/campaign/hooks/useCampaignTag';
import { useDraftDetails } from '../../hooks/useDraftDetails';
import { ProfilesDraftFooter } from '../ProfilesDraftFooter';

type ProfilesDraftProps = {
  view: string;
  post: RpcUpdate;
  basic: boolean;
  geolocationName: string;
  postContent: RpcPostContent;
  profileService: string;
  isConfirmingDelete: boolean;
  isDeleting: boolean;
  isWorking: boolean;
  isMoving: boolean;
  draftDetails: {
    draftId: string;
    postAction: string;
    creatorName: string;
    avatarUrl: string;
    createdAt: string;
  };
  campaignDetails: {
    id: string;
    name: string;
    color: string;
  };
  channelData: {
    googlebusiness: {
      cta: string;
      link: string;
      title: string;
      start_date: number;
      end_date: number;
      start_time: string;
      end_time: string;
      code: string;
      terms: string;
    };
    instagram: {
      share_to_feed: boolean;
    };
    startPage?: {
      cta: string;
      link: string;
      title: string;
      start_date: number;
      end_date: number;
      start_time: string;
      end_time: string;
    };
  };
  onDeleteConfirmClick: () => void;
  onApproveClick: () => void;
  onRevertApprovalClick: () => void;
  onRequestApprovalClick: () => void;
  onRescheduleClick: () => void;
  onEditClick: () => void;
};

export const ProfilesDraft = ({
  view,
  basic,
  geolocationName,
  profileService,
  postContent,
  isDeleting,
  isConfirmingDelete,
  isMoving,
  isWorking,
  onApproveClick,
  onDeleteConfirmClick,
  onEditClick,
  onRevertApprovalClick,
  onRequestApprovalClick,
  onRescheduleClick,
  channelData,
  post,
}: ProfilesDraftProps): JSX.Element => {
  const { postAction, ...headerDetails } = useDraftDetails(post);
  const { campaignDetails, onCampaignTagClick } = useCampaignTag(post);

  return (
    <Draft
      postId={post.id}
      updateType={post.updateType}
      basic={basic}
      geolocationName={geolocationName}
      postContent={postContent}
      profileService={profileService}
      headerDetails={headerDetails}
      channelData={channelData}
      annotations={post?.annotations}
      comments={post.comments}
    >
      {campaignDetails && (
        <PostTag
          name={campaignDetails.name}
          color={campaignDetails.color}
          // Drafts aren't draggable
          dragging={false}
          onPostTagClick={onCampaignTagClick}
        />
      )}

      <ProfilesDraftFooter
        view={view}
        draft={post}
        postAction={postAction}
        isDeleting={isDeleting}
        isConfirmingDelete={isConfirmingDelete}
        isMoving={isMoving}
        isWorking={isWorking}
        onApproveClick={onApproveClick}
        onDeleteConfirmClick={onDeleteConfirmClick}
        onEditClick={onEditClick}
        onRevertApprovalClick={onRevertApprovalClick}
        onRequestApprovalClick={onRequestApprovalClick}
        onRescheduleClick={onRescheduleClick}
      />
    </Draft>
  );
};

ProfilesDraft.defaultProps = {
  basic: false,
  geolocationName: null,
  isConfirmingDelete: false,
  isDeleting: false,
  isWorking: false,
  isMoving: false,
  channelData: null,
  onDeleteConfirmClick: null,
  onApproveClick: null,
  onRevertApprovalClick: null,
  onRequestApprovalClick: null,
  onRescheduleClick: null,
  onEditClick: null,
};
